"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SubmissionErrorMessages = void 0;
var styled_1 = __importDefault(require("@emotion/styled"));
var react_1 = __importDefault(require("react"));
var ErrorMessage_1 = require("./ErrorMessage");
var shared_1 = require("./shared");
var StyledWrapper = styled_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ul {\n    list-style: none;\n    > li + li {\n      margin-top: 4px;\n    }\n  }\n  ", "\n"], ["\n  ul {\n    list-style: none;\n    > li + li {\n      margin-top: 4px;\n    }\n  }\n  ", "\n"])), (0, ErrorMessage_1.getErrorMessageStyles)(ErrorMessage_1.ERROR_MESSAGE_TYPE.submission));
var SubmissionErrorMessages = function (_a) {
    var errorMessages = _a.errorMessages, displayError = _a.displayError, className = _a.className;
    return (react_1.default.createElement(StyledWrapper, { "data-error-type": ErrorMessage_1.ERROR_MESSAGE_TYPE.submission, className: className }, displayError && (0, shared_1.hasErrorMessages)(errorMessages) && (react_1.default.createElement("div", { role: "alert" },
        react_1.default.createElement("ul", null, errorMessages.map(function (message, i) { return (react_1.default.createElement("li", { key: i },
            react_1.default.createElement(ErrorMessage_1.ErrorMessage, { errorMessage: message }))); }))))));
};
exports.SubmissionErrorMessages = SubmissionErrorMessages;
var templateObject_1;
